export function removeEmpty(obj) {
  return Object.entries(obj)
    .filter(([, v]) => ![null, undefined, ''].includes(v))
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
}
